import {getValidToken} from "../../core/authentication/Keycloak.js";
import {consoleLog} from '../../core/utilities/Utilities.js';
const file='Api.js';

export async function reloadAlcoholLicenses(){
    let responseUI={};
    let url='/api/reload_alcohol_licenses';
    
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'reloadAlcoholLicenses',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'reloadAlcoholLicenses',arg_name:'e',arg_value:e});
        responseUI={error:"Error - reloadAlcoholLicenses: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

export async function moveBatchWithCascade(body){
    let responseUI={};
    let url='/api/batch/move_with_cascade';
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            },
            body:JSON.stringify(body)
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file,context:'moveBatchWithCascade',arg_name:'Error',arg_value:"null response"});
        } else {
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file,context:'moveBatchWithCascade',arg_name:'e',arg_value:e});
        responseUI={error:"Error - moveBatchWithCascade: "+e.toString()};
    }
    finally{
        return responseUI;
    }
}

export async function getSKUStockBalance(body){
    let responseUI={};
    let url='/api/get_sku_stockbalance';
    
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            },
            body:JSON.stringify(body)
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'getSKUStockBalance',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'getSKUStockBalance',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getSKUStockBalance: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

export async function getSKUBatchSummary(body){
    let responseUI={};
    let url='/api/get_sku_batch_summary';
    
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            },
            body:JSON.stringify(body)
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'getSKUBatchSummary',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'getSKUBatchSummary',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getSKUBatchSummary: "+e.toString()};
    }
    finally{
        return responseUI
    }
}
export async function checkSkuPalpa(body){
    let responseUI={};
    let url='/api/check_sku_palpa';

    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            },
            body:JSON.stringify(body)
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'checkSkuPalpa',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'checkSkuPalpa',arg_name:'e',arg_value:e});
        responseUI={error:"Error - checkSkuPalpa: "+e.toString()};
    }
    finally{
        return responseUI
    }
}
